import { typeRootState } from 'src/store';
import { useSelector } from 'react-redux';

export const useGetIsMobile = () => {
    const isMobile = useSelector((state: typeRootState) => state.mobileMode.isMobile);
    return isMobile;
}
